/*
* Association common area amenities form view for authenticated users
*/

import * as React from 'react';
import * as _ from 'lodash';
// import { Row } from 'react-bootstrap';

import * as DetailFormCommon from './common';
import * as KendoWrappers from '../../common/kendoforms/componentwrappers';
// import { BootstrapColXl as Col } from '../../common/bootstrap/bootstrapcolxl';

export const ClientDetails = ({
    appText,
    handleFormInputChange,    
    handleSubmitForm,
    handleSaveChanges,
    numFormChanges,    
    formData,
    defaultInputProps,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    let inputPropsFullWidth = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        // handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
    }); 

    let inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
        // onChange: (n, v) => { handleFormInputChange(n, v); },
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
    });

    let inputProps = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
    });

    let inputPropsFullWidthOwnRow = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        colLabelXs: 12,
        colInputXs: 12,
    });

    let inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
        // onChange: (o) => { handleFormInputChange({target: { type: 'virtualized-select' }}, o); }
    });

    const inputPropsRoleCheckbox = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
    });

    return (
        <DetailFormCommon.ClientDetailFormSection title={sectionTitle}>
            <div>                               
                <KendoWrappers.KendoVirtualizedSelectInput
                    name="region.regionId"                                                
                    label={appText('region')}
                    labelKey="text"
                    valueKey="value"
                    value={formData.region.regionId}
                    options={formData.options.regions}                        
                    onChange={(o) => { handleFormInputChange({target: { name: 'region.regionId', type: 'virtualized-select' }}, o); }}
                    {...inputPropsVirtualizedSelect}                        
                />   

                <KendoWrappers.KendoVirtualizedSelectInput
                    name="clientType.clientTypeId"                                                
                    label={appText('client-type')}
                    labelKey="text"
                    valueKey="value"
                    value={formData.clientType.clientTypeId}
                    options={formData.options.clientTypes}                        
                    onChange={(o) => { handleFormInputChange({target: { name: 'clientType.clientTypeId', type: 'virtualized-select' }}, o); }}
                    {...inputPropsVirtualizedSelect}                        
                />                
          
                <KendoWrappers.KendoCheckbox
                    name="inactive"
                    label={appText('inactive')}
                    value={_.get(formData, 'inactive')}
                    {...inputPropsRoleCheckbox}
                />                  
            </div>
        </DetailFormCommon.ClientDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/client/detail-form/client-details.tsx